import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  InitiateSolarConcertApplicationDto,
  SolarConcertCustomerContextDto,
} from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Create or reuse the proposal's Concert customer; the application form opens
 * with the context it returns. Either outcome moves the setup status, and a
 * seller-gate refusal may mean the seller's Concert user changed.
 */
export default function useInitiateSolarConcertApplication(): UseMutationResult<
  SolarConcertCustomerContextDto,
  unknown,
  { proposalId: string; body: InitiateSolarConcertApplicationDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      solarProposalService.initiateConcertApplication(proposalId, body),
    onSettled: (_context, _error, { proposalId }) => {
      for (const queryKey of [
        queryKeys.solarProposal.concertApplication(proposalId),
        queryKeys.solarProposal.concertSellerReadiness(proposalId),
      ]) {
        void queryClient.invalidateQueries({ queryKey, exact: true })
      }
    },
  })
}
